import axiosClient from '@/api/axiosClient'
import { getCurrentUser } from '@/db/indexedDB'
import { IApplication, ILoanAssessment } from '@/types'

export interface ApiResponse<T> {
   detail: ILoanAssessment,
   eligibilityAssessments: T[]
}

export const ApplicationService = {
  fetchApplications: async (): Promise<IApplication[]> => {
    const user = await getCurrentUser()
    const response = await axiosClient.get(`/users/${user.id}/loan-applications`)
    return response.data.data
  },

  updateApplicationStatus: async (
    selectedApplicationId: string,
    status: string,
  ) => {
    const user = await getCurrentUser()
    const response = await axiosClient.patch(
      `/users/${user.id}/loan-applications/${selectedApplicationId}/status`,
      {
        status,
      }
    )
    return response.data.data;
  },
  fetchApplicationDetails: async (selectedApplicationID: string): Promise<ApiResponse<ILoanAssessment>> => {
    const user = await getCurrentUser()
    const response = await axiosClient.get(`/users/${user.id}/loan-applications/${selectedApplicationID}`);
    return response.data;
  }
}